import { render } from "./SignIn.vue?vue&type=template&id=64b818aa"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=64b818aa&lang=css"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__